define('bizzabo/models/Person',[
    'GSModel',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'bizzabo/models/ValidationObject'
], function(
    GSModel,
    BZAPI,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    ValidationObject
    ) {

    var Person = GSModel.extend({
        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getPerson(model.id, function(data) {
                    model.setFlagsAfterSync();
                    options.success && options.success(data, options);
                }, options.error);
            } else if (method == 'update') {
                BZAPI.updatePerson(model.toJSON(), function(data) {
                    model.setFlagsAfterSync();
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        defaults : {
            'first-name' : '',
            'last-name' : ''
        },

        initialize : function() {
            this.validationObject = new ValidationObject(this);
        },

        parse : function(response) {
            return this.unfoldPhotoSet(this.unfoldExternalIDs(this.unfoldMarkersData(response)));
        },

        getters : {
            'full-name' : function() {
                return this.get('first-name') + ' ' + this.get('last-name');
            },
            'country-name' : function() {
                var country = this.get('country');
                if (country) {
                    return Consts.Countries[country];
                }
            }
        },

        validation : {},

        saveEventBriteAccessToken : function(accessToken, successCb, failureCb) {
            var thisModel = this;
            accessToken && BZAPI.updateToken('eventbrite', accessToken, null, function(data) {
                thisModel.set('external-ids-eventbrite', 'placeholder-id');
                successCb && successCb(data);
            }, failureCb);
        },

        saveEtouchesToken : function(key, secret, successCb, failureCb) {
            var thisModel = this;
            key && secret && BZAPI.updateToken('etouches', key, secret, function(data) {
                thisModel.set('external-ids-etouches', 'placeholder-id');
                successCb && successCb(data);
            }, failureCb);
        },

        unfoldExternalIDs : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'external-ids');
        },

        unfoldMarkersData : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'markers-data');
        },

        unfoldPhotoSet : function(attrs) {
            return UTILS.unfoldAttribute(attrs, 'photo-set');
        }
    });

    return Person;

});
